export default {
  bind(el, binding) {
    if (!binding.value) return
    firebase.storage().ref(binding.value).getDownloadURL().then(url => {
      el.src = url
    }).catch((error) => el.src = '')
  },
  update(el, binding) {
    if (!binding.value) return
    firebase.storage().ref(binding.value).getDownloadURL().then(url => {
      el.src = url
    }).catch((error) => el.src = '')
  },
}
// match /messages/{messageId} {
//
//        allow write: if request.resource.metadata['fromUid'] == request.auth.uid;
//        allow read: if resource.metadata[request.auth.uid] == request.auth.uid;
//    }

// service firebase.storage {
//   match /b/{bucket}/o {
//     match /test/hm {
//     	match /{allPaths=**} {
//       	allow read, write: if request.auth != null;
//       }
//     }
//     match /test/private {
//     	match /{allPaths=**} {
//       	allow read: if request.auth.uid in resource.metadata.users.split(',');
//       }
//     }
//   }
// }
